import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ze-cross",
  "use": "ze-cross-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"ze-cross\"><path d=\"M17.925 16.039l8.171 8.171c0.521 0.521 0.521 1.365 0 1.886s-1.365 0.521-1.886 0l-8.171-8.171-8.171 8.171c-0.521 0.521-1.365 0.521-1.886 0s-0.521-1.365 0-1.886l8.171-8.171-8.171-8.171c-0.521-0.521-0.521-1.365 0-1.886s1.365-0.521 1.886 0l8.171 8.171 8.171-8.171c0.521-0.521 1.365-0.521 1.886 0s0.521 1.365 0 1.886l-8.171 8.171z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol